import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const EmergencyBrodcast = Loadable({
  loader: () => import("./components/emergency-brodcast"),
  loading: Loading
});

export const routes = [
  {
    path: '/emergency-brodcast',
    exact: true,
    name: 'Emergency Brodcast',
    component: EmergencyBrodcast,
    // "permission": {
    //   "contactype": [

    //   ],
    //   "group": [
    //     "PLACES Admin",
    //     "Portal Admin Tile",
    //     "Emergency Broadcast"
    //   ]
    // }
  }
];